import {Component, OnInit, Input, Inject, ElementRef, PLATFORM_ID, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule, NgOptimizedImage, isPlatformBrowser} from '@angular/common';
import { JsonLdService } from '../../services/json-ld.service';
import {WordpressService} from "../../services/wordpress.service";
import {first} from "rxjs";
import {BlogList} from "../../models/blogList.model";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-blog-slider',
  templateUrl: './blog-slider.component.html',
  styleUrls: ['./blog-slider.component.less'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    RouterLink,
    NgOptimizedImage,
    CommonModule
  ]
})
export class BlogSliderComponent implements OnInit {
  @Input() currentArticle: number | undefined;
  posts: BlogList[] = [];

  constructor(
    private el: ElementRef,
    private WordPressService: WordpressService,
    private jsonLdService: JsonLdService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  ngOnInit(): void {
    this.WordPressService.getArticles(5).pipe(first()).subscribe(posts => {
      this.posts = posts;
      this.injectJsonLd(posts);
      setTimeout(() => this.initSwiper(), 0);
    })
  }

  private initSwiper(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const swiperEl = this.el.nativeElement.querySelector('swiper-container');
    if (!swiperEl) return;
    Object.assign(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: { delay: 3000, disableOnInteraction: false },
      pagination: { clickable: true },
      autoHeight: true,
      breakpoints: { 1100: { slidesPerView: 2, spaceBetween: 20 } },
    });
    swiperEl.initialize();
  }

  private injectJsonLd(posts: BlogList[]): void {
    const data = {
      "@context": "https://schema.org",
      "@graph": posts.map(post => ({
        "@type": "BlogPosting",
        "headline": post.title.rendered,
        "image": post.yoast_head_json?.og_image?.[0]?.url,
        "datePublished": new Date(post.date).toISOString(),
        "author": { "@type": "Person", "name": "Dart Rock Café Team" },
        "publisher": {
          "@type": "Organization",
          "name": "Dart Rock Café",
          "logo": {
            "@type": "ImageObject",
            "url": "https://dart-rock-cafe.de/assets/images/DRC-Logo.svg"
          }
        },
        "mainEntityOfPage": `https://dart-rock-cafe.de/magazin/${post.slug}`,
        "url": `https://dart-rock-cafe.de/magazin/${post.slug}`,
        "description": post.excerpt?.rendered?.replace(/<[^>]+>/g, '')
      }))
    };

    this.jsonLdService.addData(data);
  }
}
